module.exports = __webpack_public_path__ + "static/media/golfweek-flag.66a6ac80.svg";